import { IStringerGeometry } from '@stair-craft/common/util';

import { ISpiralLayout, POLE_DIAMETER } from '../spiral-calculate-layout/calculate-layout';

/** Central pole as an `IStringerGeometry` (side `'center'`); the renderer draws it as a cylinder. */
export function generatePole(layout: ISpiralLayout): IStringerGeometry {
    const cx: number = layout.outerRadius;
    const cz: number = layout.outerRadius;

    return {
        side: 'center',
        points: [
            { x: cx, y: 0, z: cz },
            { x: cx, y: layout.stepCount * layout.riserHeight, z: cz },
        ],
        thickness: POLE_DIAMETER,
        width: POLE_DIAMETER,
    };
}
